import { Prisma } from '@prisma/client';
var IncludeApiUsage = Prisma.validator()({});
//# sourceMappingURL=ApiUsage.js.map